import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import ComponentContext from "../../../contexts/ComponentContext";
import { contractTypeMap, hoursTypeMap } from "../../helpers/vacancyHelpers";
import VacancyImage from "../SearchResults/VacancyImage";

function DefaultVacancyHead(props) {
  const { vacancy, thumbnailUrl, isForm, companyName, hideImage } = props;

  const Head = isForm ? "h2" : "h1";
  const { cityInTitle, showCloseDate } = useContext(ComponentContext);

  let titleText = vacancy.title || vacancy.jobTitle;

  if (vacancy?.location?.city && cityInTitle) {
    titleText = `${vacancy?.location?.city} - ${vacancy.jobTitle}`;
  }

  const hasCompanyName = vacancy?.company?.name || companyName;

  const backgroundClassNames = classNames("fs-5", {
    "text-muted": !isForm,
  });

  let endDate = vacancy?.endDate;

  if (endDate) {
    const dateObject = new Date(endDate);

    // Checking if the date is valid
    if (!Number.isNaN(dateObject.getTime())) {
      endDate = dateObject.toLocaleDateString();
    } else {
      endDate = undefined;
    }
  }

  return (
    <div className="d-flex flex-grow-1">
      {hideImage ? null : (
        <VacancyImage
          imageUrl={vacancy?.company?.logoUrlFull || thumbnailUrl}
        />
      )}
      <div className="me-auto pe-3">
        <Head className="fw-bold vacancy-heading">{titleText}</Head>
        <div className="vacancy-description">
          {hasCompanyName && (
            <p className={backgroundClassNames}>
              {vacancy?.company?.name || companyName}
            </p>
          )}
          <div className="mb-0 mt-3 d-flex gap-2 flex-wrap">
            <span className="mb-0  vacancy-city">{vacancy.location?.city}</span>
            {vacancy.location?.city?.length > 0 &&
            vacancy.remuneration?.description?.length > 0
              ? "\u2022"
              : ""}
            <span className="mb-0 vacancy-remuneration">
              {vacancy.remuneration?.description}
            </span>
            {vacancy.remuneration?.description?.length > 0 &&
            hoursTypeMap[vacancy?.hoursType] &&
            hoursTypeMap[vacancy?.hoursType].length > 0
              ? "\u2022"
              : ""}
            <span className="mb-0 vacancy-hoursType">
              {hoursTypeMap[vacancy?.hoursType]}
            </span>
            {hoursTypeMap[vacancy?.hoursType] &&
            hoursTypeMap[vacancy?.hoursType]?.length > 0 &&
            contractTypeMap[vacancy?.contractType] &&
            contractTypeMap[vacancy?.contractType]?.length > 0
              ? "\u2022"
              : ""}
            <span className="mb-0 vacancy-contractType">
              {contractTypeMap[vacancy?.contractType]}
            </span>
          </div>
        </div>
        {showCloseDate && endDate ? (
          <div className="pt-3 close-date fw-bold">Close date: {endDate}</div>
        ) : null}
      </div>
    </div>
  );
}

export default observer(DefaultVacancyHead);

DefaultVacancyHead.propTypes = {
  companyName: PropTypes.string,
  hideImage: PropTypes.bool,
  isForm: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  vacancy: PropTypes.shape({
    contractType: PropTypes.string,
    hoursType: PropTypes.string,
    location: PropTypes.shape({ city: PropTypes.string }),
    remuneration: PropTypes.shape({
      description: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
};

DefaultVacancyHead.defaultProps = {
  companyName: null,
  hideImage: false,
  isForm: false,
  thumbnailUrl: null,
  vacancy: null,
};
